import { render, staticRenderFns } from "./OrderDetailFlightView.vue?vue&type=template&id=72f79087&scoped=true"
import script from "./OrderDetailFlightView.vue?vue&type=script&lang=js"
export * from "./OrderDetailFlightView.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailFlightView.vue?vue&type=style&index=0&id=72f79087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f79087",
  null
  
)

export default component.exports